<!-- Modal Header -->
<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa"  
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"  
       style="margin-right: 10px; cursor: pointer;"  
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- Modal Body -->
<div class="modal-body" [hidden]="minimise">
  
  <!-- Edit Mode: Entity Information Table -->
  @if (!isCreate) {
<div class="divShadow1">
    <table class="table table-bordered custom-table" style="border: 1px solid #ddd; border-collapse: collapse; padding: 4px;">
      <thead style="white-space:nowrap;">
        <tr>
          <th rowspan="2" style="width: 5%;">HO LEID</th>
          <th rowspan="2" style="width: 4%;">LEID</th>
          <th rowspan="2" style="width: 4%;">Tax Code</th>
          <th rowspan="2" style="width: 4%;">Reporting Period</th>
          <th rowspan="2" style="width: 4%;">ME Code</th>
          <th rowspan="2" style="width: 5%;">LE Name</th>	
        </tr>
      </thead>
      <tbody>
        <tr style="border: 1px solid #ddd; padding: 4px;">
          <td>{{ rowData.HO_LEID }}</td>
          <td>{{ rowData.LEID }}</td>
          <td>{{ rowData.CDR_NO }}</td>
          <td>{{ rowData.REPORTING_PERIOD }}</td>
          <td>{{ rowData.ME_CODE }}</td>
          <td>{{ rowData.LE_NAME }}</td>	
        </tr>
      </tbody>
    </table>
  </div>
}

  <!-- CREATE MODE: Add Adjustment Form -->
  @if (isCreate) {
<div class="panel panel-default">
    <div class="panel-body">
      <div>
        <div class="mb-30" style="margin-bottom: 30px;">
          <!-- Entity Selection with Search -->
          <div class="form-group col-xs-12 col-md-4" style="display: inline-block; width: 33%; margin-right: 10px;">
            <label for="entity" class="control-label">Entity <span style="color: red;">*</span></label>
            <div class="custom-select-wrapper">
              <div class="dropdown" [class.open]="isEntityDropdownOpen">
                <button #entityDropdownButton type="button" class="form-control dropdown-toggle" (click)="toggleEntityDropdown()" style="text-align: left;">
                  @if (!entity) {
<span>Select...</span>
}
                  @if (entity) {
<span>{{ entity.VALUE }}</span>
}
                  <i class="fa fa-caret-down dropdown-caret"></i>
                </button>
              </div>
            </div>
          </div>
          
          <!-- Dropdown menu as portal outside modal (fixed positioning) -->
          @if (isEntityDropdownOpen) {
<div #entityDropdownMenu class="dropdown-menu-portal">
            <div class="custom-select-search" style="padding: 5px;">
              <input 
                type="text" 
                class="form-control" 
                placeholder="Search..." 
                [(ngModel)]="entitySearchTerm"
                (ngModelChange)="filterEntities()"
                (click)="$event.stopPropagation()"
                autocomplete="off"
                style="width: 100%;">
            </div>
            <ul class="dropdown-list" style="list-style: none; padding: 0; margin: 0;">
              @for (item of filteredEntityDetails; track $index) {
<li 
                  (click)="selectEntity(item)"
                  style="padding: 8px 12px; cursor: pointer;"
                  [class.active]="entity && entity.KEY === item.KEY">
                {{ item.VALUE }}
              </li>
}
              @if (filteredEntityDetails.length === 0) {
<li 
                  style="padding: 8px 12px; color: #999; font-style: italic;">
                No results match "{{ entitySearchTerm }}"
              </li>
}
            </ul>
          </div>
}

          <!-- Adjustment Name -->
          @if (entity && entity.KEY) {
<div class="form-group col-xs-12 col-md-2" style="display: inline-block; width: 18%; margin-right: 10px;">
            <label for="adjustmentName" class="control-label">Adjustment Name <span style="color: red;">*</span></label>
            <input class="form-control" [(ngModel)]="adjustmentName" />
          </div>
}

          <!-- Adjustment Amount -->
          @if (entity && entity.KEY) {
<div class="form-group col-xs-12 col-md-2" style="display: inline-block; width: 18%; margin-right: 10px;">
            <label for="adjustmentAmount" class="control-label">Adjustment Amount <span style="color: red;">*</span></label>
            <input 
              type="text" 
              class="form-control" 
              [(ngModel)]="adjustmentAmount" 
              (keyup)="settingAdjustmentAmount($event)" />
          </div>
}

          <!-- Comments -->
          @if (entity && entity.KEY) {
<div class="form-group col-xs-12 col-md-4" style="display: block; width: 100%; margin-top: 15px;">
            <label for="comments" class="control-label">Comments</label>
            <textarea 
              maxlength="500" 
              class="form-control" 
              [(ngModel)]="comments" 
              rows="3"></textarea>
            <div style="text-align: right; font-weight: normal; vertical-align: bottom;">
              <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
            </div>	
          </div>
}
        </div>
      </div>
    </div>
  </div>
}

  <!-- EDIT MODE: Adjustment Details Table -->
  @if (!isCreate) {
<form name="screenFrom" class="form-horizontal" novalidate>
    <div class="panel-body">
      <div style="padding-top: 0 !important;">
        <!-- Small loader for form content -->
        @if (showFormLoader) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin gt-refresh"></i>
        </div>
}

        @if (!showFormLoader) {
<div>
          <table class="main-table" style="min-width: 800px !important; width: 98%;">
            <thead>
              <tr>
                <th class="sticky-col" style="text-align: center;"></th>
                <th class="sticky-col" style="text-align: center;">Adjustment Name</th>
                <th class="sticky-col" style="text-align: center;">Adjustment Amount</th>
                <th class="sticky-col" style="text-align: center;">Comments</th>
              </tr>
            </thead>
            <tbody>
              @for (t of intExpAdjDetails; track trackByIndex(i, t); let i = $index) {
<tr 
                  style="padding: 4px;" 
                  [hidden]="t.isDeleted">
                <td style="width: 2%;">
                  <i style="font-size: 24px; cursor: pointer;"
                     class="fa fa-minus-circle color-red" 
                     title="Remove Adjustment"
                     (click)="confirmDelete(t)"></i>
                </td>

                <td style="width: 20%;">
                  <input 
                    [id]="'adj_name' + i" 
                    type="text" 
                    class="form-control custom-textbox" 
                    [(ngModel)]="t.ADJ_NAME" 
                    [name]="'adj_name' + i"
                    (ngModelChange)="updatedRow(t)">
                </td>

                <td style="width: 10%;">
                  <input 
                    [id]="'amount' + i" 
                    type="number" 
                    class="form-control custom-textbox" 
                    [(ngModel)]="t.AMOUNT" 
                    [name]="'amount' + i"
                    (ngModelChange)="updateTotal(); updatedRow(t)">
                </td>

                <td style="width: 20%;">
                  <input 
                    [id]="'comments' + i" 
                    type="text" 
                    maxlength="500" 
                    class="form-control custom-textbox" 
                    [(ngModel)]="t.COMMENTS" 
                    [name]="'comments' + i"
                    (ngModelChange)="updatedRow(t)">
                </td>
              </tr>
}

              <tr>
                <td style="font-weight: bold; margin-left: 5%; padding-left: 4%;" colspan="2">
                  <label><strong>Total</strong></label>
                </td>
                <td style="font-weight: bold; padding-left: 1%;">{{total ? total : null}}</td>
                <td>
                  <div style="text-align: right; font-weight: normal; vertical-align: top;">
                    <label style="font-weight: normal; font-size: x-small; color: gray;">Max length 500</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
}
      </div>
    </div>
  </form>
}
</div>

<!-- Modal Footer -->
<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" 
          type="button" 
          [disabled]="isSaveClicked" 
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
  <button class="reset-button" 
          type="button" 
          (click)="reset()">Reset</button>
  <button class="cancel-button" 
          type="button" 
          (click)="cancel()">Cancel</button>
</div>
